/**
 * Programación de trabajos card for InspeccionDialog
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Clock, Info } from 'lucide-react';

const ProgramacionCard = ({ programacion, onChange, readOnly, todasNoProcede }) => {
  const isDisabled = readOnly || todasNoProcede;
  
  return (
    <Card className="border-[#E8E8E7]">
      <CardHeader className="pb-3">
        <CardTitle className="text-base sm:text-lg flex items-center gap-2">
          <Clock size={18} className="text-[#9d8272]" />
          Programación de Inicio de Trabajos
        </CardTitle>
      </CardHeader>
      <CardContent>
        {todasNoProcede && (
          <div className="flex items-center gap-2 p-2.5 mb-3 bg-blue-50 border border-blue-200 rounded-lg">
            <Info size={16} className="text-blue-600 flex-shrink-0" />
            <p className="text-xs text-blue-700">
              No se requiere programación — todas las solicitudes fueron evaluadas como "No procede".
            </p>
          </div>
        )}
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Label className="text-xs">Fecha Programada {!todasNoProcede && '*'}</Label>
            <Input
              type="date"
              value={programacion.fecha}
              onChange={(e) => onChange({ ...programacion, fecha: e.target.value })}
              className={`border-[#c5b8a2] text-sm ${isDisabled ? 'bg-gray-100 opacity-60' : ''}`}
              disabled={isDisabled}
              data-testid="programacion-fecha"
            />
          </div>
          <div>
            <Label className="text-xs">Hora de Inicio {!todasNoProcede && '*'}</Label>
            <Input
              type="time"
              value={programacion.horaInicio}
              onChange={(e) => onChange({ ...programacion, horaInicio: e.target.value })}
              className={`border-[#c5b8a2] text-sm ${isDisabled ? 'bg-gray-100 opacity-60' : ''}`}
              disabled={isDisabled}
              data-testid="programacion-hora"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProgramacionCard;
